export const formatSurchargeValue = (value: number) => {
  if (value === 0) return null

  const formattedValue = Math.abs(value).toFixed(2)

  return value < 0 ? `Save £${formattedValue}` : `+£${formattedValue}`
}
